export const CustomerBase = {
    status: [
        { id: 0, name: "Tất cả" },
        { id: 1, name: "Đã duyệt" },
        { id: 2, name: "Chưa duyệt" }
    ],
    type: [
        { id: 0, name: "Tất cả" },
        { id: 1, name: "Tập Tĩnh" },
        { id: 2, name: "Tập Động" },
        { id: 3, name: "Thống kê" }
    ],
    customize_type: [
        { id: 1, name: "dynamic" },
        { id: 2, name: "not dynamic" },
    ],
    Firebase_Topic: [
        { id: 1, name: "subcribe" },
        { id: 2, name: "unsubcribe" }
    ]
}

export const PLATFORMIDS = [
    { label: "ANDROID", value: 1 },
    { label: "IOS", value: 2 },
    { label: "WEB", value: 3 },
    { label: "Không xác định", value: 4 },
]